export default __webpack_public_path__ + "static/media/SignUpBg.2a5ff22b.png";